module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "welcome"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "offset-sm4": ""
    }
  }, [_c('v-container', {
    staticClass: "medium-div"
  }, [_c('v-container', {
    staticClass: "without-padding container-img"
  }, [_c('v-img', {
    attrs: {
      "src": require('../../assets/logoPonce.png')
    }
  })], 1), _vm._v(" "), (!_vm.showTokenError) ? _c('div', [_c('p', {
    staticClass: "text-title"
  }, [_vm._v(_vm._s(_vm.$t('Welcome.welcome')))]), _vm._v(" "), _c('p', {
    staticClass: "text-description"
  }, [_vm._v(_vm._s(_vm.$t('Welcome.description')))]), _vm._v(" "), _c('v-form', {
    ref: "welcomeForm",
    staticClass: "signup-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSignin.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-email",
    attrs: {
      "prepend-inner-icon": "mail",
      "name": "email",
      "label": _vm.$t('Welcome.email'),
      "id": "email",
      "type": "email",
      "color": "#00202F",
      "rules": _vm.$ponceConfig.emailRules,
      "maxlength": "254",
      "validate-on-blur": "",
      "disabled": _vm.disableEmail,
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-password",
    attrs: {
      "prepend-inner-icon": "lock",
      "append-icon": !_vm.showPassword ? 'mdi-eye' : 'mdi-eye-off',
      "name": "password",
      "label": _vm.$t('Welcome.password'),
      "id": "password",
      "type": "password",
      "color": "#00202F",
      "rules": _vm.$ponceConfig.passwordRules,
      "validate-on-blur": "",
      "required": ""
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-password",
    attrs: {
      "prepend-inner-icon": "lock",
      "append-icon": !_vm.showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off',
      "name": "passwordConfirmation",
      "label": _vm.$t('Welcome.passwordConfirmation'),
      "id": "password",
      "type": _vm.showPasswordConfirmation ? 'text' : 'password',
      "color": "#00202F",
      "rules": _vm.$ponceConfig.passwordRules,
      "validate-on-blur": "",
      "required": ""
    },
    on: {
      "click:append": function($event) {
        _vm.showPasswordConfirmation = !_vm.showPasswordConfirmation
      }
    },
    model: {
      value: (_vm.passwordConfirmation),
      callback: function($$v) {
        _vm.passwordConfirmation = $$v
      },
      expression: "passwordConfirmation"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "submit-btn",
    attrs: {
      "block": "",
      "type": "submit",
      "loading": _vm.loading
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('Welcome.confirm')) + "\n                  ")])], 1)])], 1)], 1)], 1) : _c('div', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "text-title mb-4"
  }, [_vm._v(_vm._s(_vm.$t('Welcome.tokenInvalid')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-none text-h6",
    attrs: {
      "loading": _vm.resendLoading,
      "color": "#0098E1",
      "dark": ""
    },
    on: {
      "click": _vm.resendInvitationByToken
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Welcome.resendInvitation')) + "\n            "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("forward_to_inbox")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-div"
  }, [_c('p', {
    staticClass: "bottom-text"
  }, [_vm._v("PONCE")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b721679","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/Welcome.vue
// module id = 1712
// module chunks = 0